import { RedirectStateFunction, RedirectionStateObject } from '../types';
import { parseStringifyValues, pickOsdParams, splitOsdResource, tanstackUrlSearch } from '../utils';
import { kibanaRouteName, legacyKibanaRouteName } from 'states/osd/osd.route.params';
import { grafanaStateName, metricsRouteName } from 'states/grafana/grafana.routes.names';

const redirectToOsd: RedirectStateFunction = ({ resource, ...params }) => {
  const { app, hash } = splitOsdResource(resource);

  // `hash` goes last so the resource-derived value always wins over a stale param of the same name.
  return `/360/oss/logs/${app}${tanstackUrlSearch({ ...pickOsdParams(params), hash })}`;
};

const redirectToMetrics: RedirectStateFunction = ({ resource, ...params }) =>
  `/360/oss/metrics/${resource}${tanstackUrlSearch(parseStringifyValues(params))}`;

// The legacy aliases need their own entry even though they only `redirectTo` the states above: their
// `onBefore` fires first, and an unmapped state falls back to a bare `/360/` that drops the deep link.
// Scheduled-report Slack and email links are still minted server-side as `#/dashboard/kibana/...`.
export const OssRedirections: RedirectionStateObject = {
  [kibanaRouteName]: redirectToOsd,
  [legacyKibanaRouteName]: redirectToOsd,
  [metricsRouteName]: redirectToMetrics,
  [grafanaStateName]: redirectToMetrics,
};
